import { getReactAppConfig } from "shared/functions";

export enum AuthKeys {
  ACCESS_TOKEN = "ACCESS_TOKEN",
  REFRESH_TOKEN = "REFRESH_TOKEN",
  GOOGLE_STATE = "GOOGLE_STATE", // session storage key for Google OAuth state
}

const FACEBOOK_REDIRECT_URI = `${window.location.origin}/auth/facebook/callback`;

const authService = (): {
  setAccessToken: (accessToken: string) => void;
  setRefreshToken: (refreshToken: string) => void;
  clearSession: () => void;
  getAccessToken: () => string | null;
  getRefreshToken: () => string | null;
  handleFacebookLogin: () => void;
} => {
  const setAccessToken = (accessToken: string) => {
    localStorage.setItem(AuthKeys.ACCESS_TOKEN, accessToken);
  };

  const setRefreshToken = (refreshToken: string) => {
    localStorage.setItem(AuthKeys.REFRESH_TOKEN, refreshToken);
  };

  const clearSession = () => {
    localStorage.removeItem(AuthKeys.ACCESS_TOKEN);
    localStorage.removeItem(AuthKeys.REFRESH_TOKEN);
  };

  const getAccessToken = () => localStorage.getItem(AuthKeys.ACCESS_TOKEN);

  const getRefreshToken = () => localStorage.getItem(AuthKeys.REFRESH_TOKEN);

  const handleFacebookLogin = () => {
    const config = getReactAppConfig();

    const facebookAuthUrl = `https://www.facebook.com/v23.0/dialog/oauth
    ?client_id=${config.FACEBOOK_APP_ID}
    &redirect_uri=${encodeURIComponent(FACEBOOK_REDIRECT_URI)}
    &response_type=code
    &scope=email,public_profile`.replace(/\s/g, "");

    window.location.href = facebookAuthUrl;
  };

  return {
    setAccessToken,
    setRefreshToken,
    clearSession,
    getAccessToken,
    getRefreshToken,
    handleFacebookLogin,
  };
};

export default authService;
